import styled from "styled-components";
import LoggedInBoilerplate from "../LoggedInBoilerplate";
import BigButton from "../BigButton";
import UpcomingActivitiesSection from "../activity/upcomingActivities/UpcomingActivitiesSection";
import AnnouncementSection from "../announcements/AnnouncementSection";
import { useTranslation } from "react-i18next";
import HelloUserSection from "../announcements/HelloUserSection";
import { useContext, useEffect, useState } from "react";
import Context from "../../../../Context";
import { TbReportMedical } from "react-icons/tb";
import {
  FaBox,
  FaBoxOpen,
  FaFileMedical,
  FaHandHoldingMedical,
} from "react-icons/fa";
import { HiMiniShoppingBag } from "react-icons/hi2";
import { GrAnnounce } from "react-icons/gr";
import { IoMdFitness } from "react-icons/io";
import { IoBodyOutline, IoMedical } from "react-icons/io5";
import { IoIosFitness } from "react-icons/io";
import BrandContainer from "../../../brand/BrandContainer";
import MembershipMiniInfo from "../MembershipMiniInfo";
import MyActivitiesHeaderButton from "../MyActivitiesHeaderButton";
import Footer from "../../loggedOut/landingPage/Footer";
import fetchDataWithCaching from "../../../../controllers/network/fetchDataWithCaching";
import PullToRefresh from "react-simple-pull-to-refresh";
import filterUpcomingActivityTypes from "../../../../controllers/filterUpcomingActivityTypes";
import LoadingSection from "../../../helperComponents/LoadingSection";
import { BsBoxSeam, BsJournalMedical } from "react-icons/bs";
import { TfiAnnouncement } from "react-icons/tfi";
import { AiOutlineShopping } from "react-icons/ai";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 100px;
  /* margin-top: 50px; */

  @media (max-width: 900px) {
    gap: 50px;
  }
`;

const FirstRow = styled.div`
  display: flex;
  flex-direction: row;
  width: 90vw;
  justify-content: space-between;
  gap: 50px;

  @media (max-width: 900px) {
    flex-direction: column;
    gap: 40px;
    margin-top: -20px;
  }
`;

const Section = styled.div`
  display: flex;
  flex-direction: column;
  /* justify-content: space-between; */
  gap: 30px;
  flex: 1;

  @media (max-width: 900px) {
    gap: 15px;
    margin-top: 15px;
  }
`;

const Title = styled.div`
  font-size: 18px;
  font-weight: 300;
  color: var(--accentColor);
  opacity: 0.8;
`;
const List = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 20px;
  width: 100%;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;

  @media (max-width: 900px) {
    grid-template-columns: 1fr 1fr;
  }
`;

const MobileHomeHeader = styled.div`
  display: none;

  @media (max-width: 900px) {
    margin-top: 30px;
    display: flex;
    flex-direction: column;
    gap: 20px;
  }
`;

const MobileRow = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

export default function HomePage() {
  const { updateLoggedInUser, updateMembershipPlans, adminSettings } =
    useContext(Context);
  const [announcements, setAnnouncements] = useState(null);
  const [activityTypes, setActivityTypes] = useState(null);

  useEffect(() => {
    loadStuff();
  }, []);

  async function loadStuff(skipCache) {
    let data2 = await fetchDataWithCaching({
      path: "/announcements",
      onFreshData: setAnnouncements,
      skipCache,
    });
    setAnnouncements(data2);
    let data3 = await fetchDataWithCaching({
      path: "/activity-types",
      onFreshData: setActivityTypes,
      skipCache: skipCache,
    });
    setActivityTypes(data3);
    await updateLoggedInUser();
    await updateMembershipPlans();
  }

  const { isMobile } = useContext(Context);
  const { t } = useTranslation();

  let announcementButton = (
    <BigButton
      // iconImage={"announcements"}
      link="/announcements"
      // icon={<IoMedical />}
      icon={<TfiAnnouncement />}
    >
      {t("menuItemAnnouncements")}
    </BigButton>
  );

  let shoppingButton = (
    <BigButton
      // iconImage={"shopping"}
      link="/shopping"
      // icon={<HiMiniShoppingBag />}
      icon={<AiOutlineShopping />}
    >
      {t("menuItemShopping")}
    </BigButton>
  );

  let myActivitiesButton = (
    <BigButton
      // iconImage={"activities"}
      link="/my-bookings"
      icon={<IoIosFitness />}
    >
      {t("menuItemMyActivities")}
    </BigButton>
  );

  let myOrdersButton = (
    <BigButton
      // iconImage={"orders"}
      link="/my-orders"
      // icon={<FaBoxOpen />}
      icon={<BsBoxSeam />}
    >
      {t("menuItemMyOrders")}
    </BigButton>
  );

  if (isMobile) {
    announcementButton = null;
    shoppingButton = null;
    myActivitiesButton = null;
    myOrdersButton = null;
  }

  if (!adminSettings)
    return (
      <LoggedInBoilerplate showFooter={true}>
        <LoadingSection />
      </LoggedInBoilerplate>
    );

  if (!adminSettings.data)
    return (
      <LoggedInBoilerplate showFooter={true}>
        <LoadingSection />
      </LoggedInBoilerplate>
    );

  return (
    <PullToRefresh
      // refreshingContent={false}
      onRefresh={loadStuff}
    >
      <LoggedInBoilerplate showFooter={true}>
        <Container>
          <MobileHomeHeader>
            <MobileRow>
              <HelloUserSection />
              <BrandContainer />
            </MobileRow>

            <MobileRow>
              <MembershipMiniInfo />
              <MyActivitiesHeaderButton />
            </MobileRow>
          </MobileHomeHeader>

          <FirstRow>
            <AnnouncementSection selfLoading={false} data={announcements} />

            <Section>
              <List>
                <BigButton
                  link={`/activity-type/?itemID=${adminSettings.data.healthCheckupActivityTypeID}`}
                  // iconImage={"book-health-checkup"}
                  // icon={<FaHandHoldingMedical />}
                  icon={<IoBodyOutline />}
                >
                  {t("menuItemReserveHealthCheckUp")}
                </BigButton>

                <BigButton
                  link={`/my-bookings/?activityTypeID=${adminSettings.data.healthCheckupActivityTypeID}`}
                  // iconImage={"health-reports"}
                  // icon={<FaFileMedical />}
                  icon={<BsJournalMedical />}
                >
                  {t("menuItemHealthReports")}
                </BigButton>

                {myActivitiesButton}

                {myOrdersButton}

                {announcementButton}

                {shoppingButton}
              </List>
            </Section>
          </FirstRow>

          <UpcomingActivitiesSection
            data={filterUpcomingActivityTypes(activityTypes)}
          />
        </Container>
      </LoggedInBoilerplate>
    </PullToRefresh>
  );
}
